import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisStackBarChartResponseDto,
  IAnalysisStackBarChartResultVo,
} from '../types';

import {
  normalizeTableDataList,
  pickAxisChartWireVo,
  pickChartDisplayMeta,
} from './common';

export function transformStackBarChartResponseDtoToVo(
  dto: IAnalysisStackBarChartResponseDto,
): IAnalysisStackBarChartResultVo {
  const {
    stack_bar_chart: stackBarChartWire,
    table_data: tableDataWire,
  } = dto;
  const { chartData: stackBarChart, isNoData } =
    pickAxisChartWireVo(stackBarChartWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.StackBar,
    isNoData,
    ...(isNoData
      ? {}
      : {
          stackBarChart,
          tableData: normalizeTableDataList(tableDataWire),
        }),
  };
}
